import logoSource from '/static/assets/images/logo.png';
import {ReactNode} from 'react';
import Navigation from '../sidebar-navigation';
import DemoAccountBar from './@components/demo-account-bar';
import styles from './styles.module.scss';
import useDemoAccountDetails from 'ui/@hooks/use-demo-account-details';
import BgGradientLeftIcon from './assets/bg-gradient-left.svg?react';
import BgGradientRightIcon from './assets/bg-gradient-right.svg?react';

type PageTemplateVariants = 'primary' | 'secondary';

interface ElementProps {
  children: ReactNode;
  hideNavigation?: boolean;
  variant?: PageTemplateVariants;
  v2Background?: boolean;
}

const PageTemplate = ({
  children,
  hideNavigation = false,
  variant = 'primary',
  v2Background = false,
}: ElementProps) => {
  const {poweredBy, showDemoBar} = useDemoAccountDetails();

  if (variant === 'primary') {
    return (
      <div className={styles.container}>
        {!hideNavigation && <Navigation />}

        <div
          className={`${styles.contentWrapper} ${
            v2Background ? styles.v2Background : styles.whiteBg
          }`}
        >
          {v2Background && (
            <>
              <BgGradientLeftIcon className={styles.bgGradientTop} />

              <BgGradientRightIcon className={styles.bgGradientBottom} />
            </>
          )}

          {showDemoBar && <DemoAccountBar />}

          <div className={v2Background ? styles.contentV2 : styles.content}>
            {children}

            {poweredBy.show && (
              <p className={styles.poweredBy}>{poweredBy.text}</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.containerSecondary}>
      <div className={styles.header}>
        <img
          src={logoSource}
          alt="Instill Logo"
          role="presentation"
          className={styles.logo}
        />
      </div>

      {children}
    </div>
  );
};

export default PageTemplate;
